exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".watermark{bottom:0;font-size:6rem;opacity:.2;padding:6px;pointer-events:none;position:fixed;will-change:transform;right:0;white-space:nowrap}.watermark.production{animation:blink 3s infinite;color:red;opacity:.7}@keyframes blink{from{opacity:0}to{opacity:1}}", ""]);

// exports
